import React from 'react'
import { useLocation } from 'react-router-dom'
import { useMyContext } from '../context/context'
import useSettingsV2 from '../hooks/useSettingsV2'
import NavBar from './navbar'

const Header = () => {
  const location = useLocation()
  const { event } = useMyContext() as any
  const { settings } = useSettingsV2() as any

  if (!event || location.pathname.includes('/live/speaker') || location.pathname.includes('/live/orga')) return <div />

  return (
    <div style={{ width: '100%' }}>
      {settings && settings.headerImg ? (
        <img
          alt="header"
          src={
            settings?.headerImg?.includes('https')
              ? settings.headerImg
              : `https://gayakoa-files-eu-west-1-public.s3.eu-west-1.amazonaws.com/${settings.headerImg}`
          }
          style={{ width: '100%', display: 'block', backgroundColor: settings?.backgroundColor }}
        />
      ) : (
        <div style={{ padding: '20px 0', textAlign: 'center', marginBottom: 10 }}>{event.name}</div>
      )}
      <NavBar />
    </div>
  )
}

export default Header
